/** Demo comercial v0.2.0 — solo frontend; nombres y escenarios para ventas. */

export const DEMO_PAYSLIPS = [
  {
    id: 'ps1',
    period: '2026-01',
    employee: 'Martín Gómez',
    area: 'Tecnología',
    status: 'signed',
    issuedAt: '2026-02-05',
  },
  {
    id: 'ps2',
    period: '2026-01',
    employee: 'Sofía Herrera',
    area: 'Comercial',
    status: 'available',
    issuedAt: '2026-02-04',
  },
  {
    id: 'ps3',
    period: '2025-12',
    employee: 'Diego Rojas',
    area: 'Soporte',
    status: 'pending',
    issuedAt: '2026-01-28',
  },
  {
    id: 'ps4',
    period: '2026-01',
    employee: 'Lucía Fernández',
    area: 'Administración',
    status: 'observed',
    issuedAt: '2026-02-03',
  },
  {
    id: 'ps5',
    period: '2026-01',
    employee: 'Ana Martínez',
    area: 'People',
    status: 'signed',
    issuedAt: '2026-02-05',
  },
  {
    id: 'ps6',
    period: '2026-01',
    employee: 'Mauro Lucena',
    area: 'Tecnología',
    status: 'available',
    issuedAt: '2026-02-05',
  },
];

export const LEGAJO_CATALOG_TYPES = [
  'dni',
  'contract',
  'labor',
  'bank',
  'cert_med',
  'cv',
  'policies',
  'evaluation',
  'training',
];

export const DEMO_DOC_EXPIRATIONS = [
  {
    id: 'dv1',
    docKey: 'cert_med',
    employee: 'Diego Rojas',
    due: '2026-02-14',
    urgency: 'high',
    nextKey: 'legajo.nextRenewMedical',
  },
  {
    id: 'dv2',
    docKey: 'dni',
    employee: 'Lucía Fernández',
    due: '2026-03-01',
    urgency: 'medium',
    nextKey: 'legajo.nextUpdateId',
  },
  {
    id: 'dv3',
    docKey: 'policies',
    employee: 'Martín Gómez',
    due: '2026-02-28',
    urgency: 'low',
    nextKey: 'legajo.nextResignPolicies',
  },
];

export const DEMO_EVAL_CYCLES = [
  {
    id: 'cy1',
    labelKey: 'evaluations.cycleQ1',
    period: 'Q1 2026',
    audienceKey: 'evaluations.audAll',
    status: 'in_progress',
    progress: 62,
  },
  {
    id: 'cy2',
    labelKey: 'evaluations.cycleQ2',
    period: 'Q2 2026',
    audienceKey: 'evaluations.audManagers',
    status: 'draft',
    progress: 8,
  },
  {
    id: 'cy3',
    labelKey: 'evaluations.cycleAnnual',
    period: '2025',
    audienceKey: 'evaluations.audAll',
    status: 'completed',
    progress: 100,
  },
];

export const DEMO_AWARDS_FEED = [
  {
    id: 'df1',
    employee: 'Sofía Herrera',
    title: 'Cierre comercial destacado',
    reasonKey: 'awards.demoReason1',
    points: 120,
    badge: 'Estrella comercial',
    date: '2026-02-02',
  },
  {
    id: 'df2',
    employee: 'Martín Gómez',
    title: 'Excelencia técnica',
    reasonKey: 'awards.demoReason2',
    points: 90,
    badge: 'Tech champion',
    date: '2026-01-28',
  },
  {
    id: 'df3',
    employee: 'Ana Martínez',
    title: 'People partner del mes',
    reasonKey: 'awards.demoReason3',
    points: 100,
    badge: 'People',
    date: '2026-01-20',
  },
];
